/**
 * Сохранение и восстановление проекта в IndexedDB через idb-keyval.
 *
 * Используется для автосохранения (debounced) и списка последних проектов.
 *
 * ВАЖНО: проект хранится в $state и обёрнут в Proxy Svelte. IDB не умеет
 * клонировать проксированные объекты (DataCloneError), поэтому вызывающий код
 * (стор) передаёт сюда уже «чистую» копию, снятую через $state.snapshot.
 */
import { get, set, del, keys } from 'idb-keyval';
import type { Project } from '../domain/types';

const PREFIX = 'annotator:project:';
const LAST_KEY = 'annotator:lastId';

export async function saveProject(project: Project): Promise<void> {
  try {
    await set(PREFIX + project.id, project);
    await set(LAST_KEY, project.id);
  } catch (err) {
    // квота или недоступность — не роняем приложение
    console.warn('[persistence] save failed', err);
  }
}

export async function loadProject(id: string): Promise<Project | undefined> {
  return get<Project>(PREFIX + id);
}

export async function loadLastProject(): Promise<Project | undefined> {
  const lastId = await get<string>(LAST_KEY);
  if (!lastId) return undefined;
  return loadProject(lastId);
}

export async function deleteProject(id: string): Promise<void> {
  await del(PREFIX + id);
}

export async function listProjects(): Promise<Project[]> {
  const allKeys = await keys();
  const projects: Project[] = [];
  for (const k of allKeys) {
    if (typeof k === 'string' && k.startsWith(PREFIX)) {
      const p = await get<Project>(k);
      if (p) projects.push(p);
    }
  }
  return projects.sort((a, b) => b.updatedAt - a.updatedAt);
}
